var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#32325D",
    d: "M12.866 12.667h-9.48V3.333h4.74V2h-4.74c-.748 0-1.355.597-1.355 1.333v9.334c0 .736.607 1.333 1.355 1.333h9.48c.745 0 1.354-.6 1.354-1.333V8h-1.354v4.667zM9.48 2v1.333h2.431L5.255 9.887l.955.94 6.656-6.554v2.394h1.354V2H9.48z",
    transform: "translate(.205 .667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0H16.252V16H0z",
    transform: "translate(.205 .667)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 0H16.252V16H0z",
    transform: "translate(.205 .667)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.d5184d533604fde56139b8577a99d369.svg";
export { ForwardRef as ReactComponent };